var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { getConfig, keysToCamelCase, keysToSnakeCase } from "@jti/fe-common";
import { getUser } from "../../utils";
import { Rest } from "../Rest";
export class SubscriptionsApi extends Rest {
    constructor(baseUrl, tenant, ciamToken) {
        super(baseUrl);
        this.name = "SubscriptionApi";
        this.setCommonHeader("X-DES-TENANT", tenant);
        ciamToken && this.setCommonHeader("X-DES-USER-TOKEN", ciamToken);
    }
    static init() {
        const user = getUser();
        const { EVO_SUBSCRIPTIONS_DOMAIN, EVO_SUBSCRIPTIONS_TENANT } = getConfig();
        return new SubscriptionsApi(EVO_SUBSCRIPTIONS_DOMAIN, EVO_SUBSCRIPTIONS_TENANT, user.ciam_token);
    }
    initRequest(uri, options) {
        return this.request(uri, options, true);
    }
    formatResponseWithPrice(response) {
        const { amount, currency } = response, rest = __rest(response, ["amount", "currency"]);
        const price = {
            value: amount,
            currency,
        };
        return Object.assign(Object.assign({}, rest), { price });
    }
    getSubscriptionConfigurations() {
        return __awaiter(this, void 0, void 0, function* () {
            const uri = "/api/subscriptions/configurations";
            const response = yield this.initRequest(uri, {});
            return keysToCamelCase(response);
        });
    }
    getUserSubscription() {
        return __awaiter(this, void 0, void 0, function* () {
            const uri = "/api/subscriptions/user";
            const response = yield this.initRequest(uri, {
                method: "GET",
            });
            const productsWithEnrichedParameters = response.products.map((product) => {
                var _a, _b;
                const optionIDs = (_b = (_a = product.options) === null || _a === void 0 ? void 0 : _a.reduce((acc, { sku, qty }) => `${acc}_${sku}_${qty}_`, "")) !== null && _b !== void 0 ? _b : [];
                return Object.assign({ _id: `${product.sku}_${optionIDs}` }, product);
            });
            const formattedResponse = this.formatResponseWithPrice(Object.assign(Object.assign({}, response), { products: productsWithEnrichedParameters }));
            const keysToCamelCaseResponse = keysToCamelCase(formattedResponse);
            return keysToCamelCaseResponse;
        });
    }
    updateSubscription(uuid, payload) {
        return __awaiter(this, void 0, void 0, function* () {
            var _a;
            const uri = `/api/subscriptions/${uuid}`;
            const preparedProducts = (_a = payload.products) === null || _a === void 0 ? void 0 : _a.map((_a) => {
                var { _id } = _a, rest = __rest(_a, ["_id"]);
                return rest;
            });
            const preparedPayload = Object.assign(Object.assign({}, payload), { products: preparedProducts });
            const requestBody = keysToSnakeCase(preparedPayload);
            const response = yield this.initRequest(uri, {
                method: "PUT",
                body: JSON.stringify(requestBody),
            });
            const formattedResponse = this.formatResponseWithPrice(response);
            return keysToCamelCase(formattedResponse);
        });
    }
    pauseUserSubscription(uuid) {
        return __awaiter(this, void 0, void 0, function* () {
            const uri = `/api/subscriptions/${uuid}/pause`;
            const response = yield this.initRequest(uri, {
                method: "PUT",
            });
            const formattedResponse = this.formatResponseWithPrice(response);
            return keysToCamelCase(formattedResponse);
        });
    }
    cancelUserSubscription(uuid) {
        return __awaiter(this, void 0, void 0, function* () {
            const uri = `/api/subscriptions/${uuid}/cancel`;
            const response = yield this.initRequest(uri, {
                method: "PUT",
            });
            return keysToCamelCase(this.formatResponseWithPrice(response));
        });
    }
    resumeUserSubscription(uuid) {
        return __awaiter(this, void 0, void 0, function* () {
            const uri = `/api/subscriptions/${uuid}/resume`;
            const response = yield this.initRequest(uri, {
                method: "PUT",
            });
            return keysToCamelCase(this.formatResponseWithPrice(response));
        });
    }
    getCardData(uuid) {
        return __awaiter(this, void 0, void 0, function* () {
            const uri = `/api/payments/cards/${uuid}`;
            const response = yield this.initRequest(uri, {
                method: "GET",
            });
            return keysToCamelCase(response);
        });
    }
}
//# sourceMappingURL=SubscriptionsApi.js.map